import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCurrencyNoDecimal } from '../../utils/currency.utils';

export interface WageClaimProps {
    value?: number;
    currencyIso?: string;
}

const WageClaim: React.FC<WageClaimProps> = ({ value, currencyIso }) => {
    const { i18n } = useTranslation();
    return <>{formatCurrencyNoDecimal(value ?? 0, currencyIso, i18n.language)}</>;
}

export default WageClaim;